import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import PropTypes from "prop-types";
// import { Manager, Target, Popper } from "react-popper";
import { logout, cambiarsucursal } from "../../store/actions/authActions";
import { getSucursales } from "../../store/actions/catalogoSucursalActions";
import { marcarVistas, registrarTokenWeb } from "../../store/actions/notificacionesActions";
import { estadoPermiso, pushConfigurado } from "../../push/firebaseMessaging";

import SweetAlert from "react-bootstrap-sweetalert";
import stylesAlerts from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import Tooltip from '@material-ui/core/Tooltip';
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Divider from "@material-ui/core/Divider";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import StoreIcon from '@material-ui/icons/Store';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOff';

// core components
import Button from "components/CustomButtons/Button.js";

import Select from "react-select";

import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";
const useStyles = makeStyles(styles);


const useStylesAlert = makeStyles(stylesAlerts);

// estilos del desplegable de la campanita (la plantilla ya no trae los del popper)
const estilosCampanita = {
  panel: { width: 360, maxWidth: "90vw", marginTop: 8, borderRadius: 6, overflow: "hidden" },
  encabezado: { padding: "10px 14px", fontSize: 13, fontWeight: 600, color: "#3c4858", background: "#f5f5f5" },
  item: { padding: "8px 14px", cursor: "pointer", fontSize: 12, color: "#3c4858", lineHeight: "16px" },
  itemNuevo: { background: "#fff8e1" },
  vacio: { padding: "14px", fontSize: 12, color: "#9e9e9e", textAlign: "center" },
  pie: { padding: "8px 14px", textAlign: "center" },
  aviso: { padding: "8px 14px", fontSize: 11, color: "#e65100", background: "#fff3e0" },
};

function HeaderLinks(props) {
  const [ sucursalesList, setSucursalesList] = React.useState([]);
  const [ sucursalState, setSucursalState] = React.useState("");
  const [ idSucursalLogueada] = React.useState(localStorage.getItem('sucursal'));
  const [ sucursalLogueada] = React.useState(localStorage.getItem('nombresucursal'));
  const [ esmatriz] = React.useState(localStorage.getItem('esmatriz'));
  const [ sucursal, setSucursal] = React.useState("");

  const [alert, setAlert] = React.useState(null);

  const [openProfile, setOpenProfile] = React.useState(null);

  // campanita de solicitudes de devolucion (solo matriz)
  const [openNotif, setOpenNotif] = React.useState(null);

  const handleLogOut = () => {
    setOpenProfile(null);
    props.logout();
  };

  const redirectToDashboard = (id, nombre) => {
    props.cambiarsucursal(id, nombre);
    setTimeout(
      () => {
        window.location.reload(true);
      }, 300
    );
  }

  React.useEffect(() => {
    if(idSucursalLogueada==1 || esmatriz=='s'){
      props.getSucursales();
    }else{
      setSucursal({value:idSucursalLogueada,label:sucursalLogueada});
    }
  }, []);

  // // // load supervisores list
  React.useEffect(() => {
      setSucursalesList(props.listDataSucursales);
  }, [props.listDataSucursales]);

  const handleSucursalChange = (selectedOption) => {
    // console.log(selectedOption);
    if(selectedOption){
        setSucursalState("success");
        setSucursal(selectedOption);
        redirectToDashboard(selectedOption.value,selectedOption.label);
    }else{
        setSucursalState("error");
        setSucursal("");
    }
  }

  const sucursalesStyles = {
      control: styles => ({ ...styles, marginTop: '27px' }),
      placeholder: styles => ({ ...styles, color: sucursalState === "error" ? '#f44336' : sucursalState === "success" ? '#4caf50' : '#AAAAAA' }),
  };

  const seleccionarSucursalClick = () => {
    htmlAlert();
  }

  const classes = useStyles();
  const classesAlert = useStylesAlert();
  const { rtlActive } = props;
  const wrapper = classNames({
    [classes.wrapperRTL]: rtlActive
  });
  const managerClasses = classNames({
    [classes.managerClasses]: true
  });

  const hideAlert = () => {
    setAlert(null);
  };

  const htmlAlert = () => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="CAMBIAR DE SUCURSAL"
        showConfirm={false}
        showCancel
        cancelBtnCssClass={classesAlert.button + " " + classesAlert.danger}
        cancelBtnText="Cancelar"
        onCancel={() => hideAlert()}
      >
        <Select
            options={sucursalesList}
            isClearable
            // isDisabled={ (idSucursalLogueada==1 && esmatriz=='s') ? false : true}
            isLoading={sucursalesList == null}
            onChange={handleSucursalChange}
            styles={sucursalesStyles}
            placeholder="Seleccionar Sucursal"
            value={sucursal}
        />
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>

      </SweetAlert>
    );
  };

  // ─── Campanita de solicitudes de devolución ───────────────────────────────

  const handleClickNotif = (event) => {
    if (openNotif && openNotif.contains(event.target)) {
      setOpenNotif(null);
    } else {
      setOpenNotif(event.currentTarget);
      props.marcarVistas();
    }
  };

  const cerrarNotif = () => { setOpenNotif(null); };

  const irAutorizar = () => {
    cerrarNotif();
    props.marcarVistas();
    if (props.history) {
      props.history.push("/admin/autorizar");
    } else {
      window.location.href = "/admin/autorizar";
    }
  };

  const activarNotificaciones = () => {
    props.registrarTokenWeb(true);
  };

  const total = props.totalPendientes;
  const permiso = estadoPermiso();
  // el permiso del navegador se pide al entrar; si el usuario lo dejo en "default"
  // (cerro el prompt) se le ofrece reintentar; con "denied" solo se le avisa
  const sinPush = pushConfigurado() && props.tokenEstado === "no_disponible" && permiso !== "granted";

  const campanita = (esmatriz != 's') ? null : (
    <div className={managerClasses}>
      <Tooltip title="Solicitudes de devolución pendientes" placement="left">
        <Button
          color="transparent"
          justIcon
          aria-label="Notifications"
          aria-owns={openNotif ? "notif-menu-list" : null}
          aria-haspopup="true"
          onClick={handleClickNotif}
          className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
          muiClasses={{
            label: rtlActive ? classes.labelRTL : ""
          }}
        >
          <NotificationsIcon
            className={
              classes.headerLinksSvg +
              " " +
              (rtlActive
                ? classes.links + " " + classes.linksRTL
                : classes.links)
            }
          />
          {total > 0 ? (
            <span className={classes.notifications} style={props.noVistas > 0 ? { background: "#ff9800" } : null}>
              {total > 99 ? "99+" : total}
            </span>
          ) : null}
        </Button>
      </Tooltip>
      <Popper
        open={Boolean(openNotif)}
        anchorEl={openNotif}
        transition
        disablePortal
        placement="bottom-end"
        style={{ zIndex: 1300 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: "right top" }}>
            <Paper style={estilosCampanita.panel} elevation={6}>
              <ClickAwayListener onClickAway={cerrarNotif}>
                <div id="notif-menu-list">
                  <div style={estilosCampanita.encabezado}>
                    {total == null
                      ? "Solicitudes de devolución"
                      : (total === 0
                        ? "Sin solicitudes de devolución pendientes"
                        : total + (total === 1 ? " solicitud de devolución pendiente" : " solicitudes de devolución pendientes"))}
                  </div>
                  {sinPush ? (
                    <div style={estilosCampanita.aviso}>
                      {permiso === "denied"
                        ? "Las notificaciones del navegador están bloqueadas para este sitio: los avisos nuevos solo se verán al abrir la campanita o Autorizar."
                        : <span>
                            Activa las notificaciones del navegador para enterarte al instante.{" "}
                            <a href="#activar" onClick={(e) => { e.preventDefault(); activarNotificaciones(); }} style={{ fontWeight: 600 }}>Activar</a>
                          </span>}
                    </div>
                  ) : null}
                  <Divider />
                  {props.recientes.length === 0 ? (
                    <div style={estilosCampanita.vacio}>
                      Aquí aparecerán las solicitudes que lleguen mientras el dashboard esté abierto.
                    </div>
                  ) : (
                    <div style={{ maxHeight: 320, overflowY: "auto" }}>
                      {props.recientes.slice(0, 10).map((r, i) => (
                        <div
                          key={r.id || i}
                          style={{ ...estilosCampanita.item, ...(i < props.noVistas ? estilosCampanita.itemNuevo : {}) }}
                          onClick={irAutorizar}
                          role="button"
                          tabIndex={0}
                        >
                          <div><b>Guía {r.guia}</b>{r.tipo === "DIRECTA" ? " · Directa" : " · Reversión"}{r.fecha ? " · " + r.fecha : ""}</div>
                          <div>{r.chofer}{r.nombresucursal ? " · Sucursal " + r.nombresucursal : ""}</div>
                          {r.motivo ? <div style={{ color: "#757575" }}>Motivo: {r.motivo}</div> : null}
                        </div>
                      ))}
                    </div>
                  )}
                  <Divider />
                  <div style={estilosCampanita.pie}>
                    <Button color="success" size="sm" onClick={irAutorizar}>Ver en Autorizar</Button>
                  </div>
                </div>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );

  return (
    <div className={wrapper}>
    {alert}
      {/* <CustomInput
        rtlActive={rtlActive}
        formControlProps={{
          className: classes.top + " " + classes.search
        }}
        inputProps={{
          placeholder: rtlActive ? "بحث" : "Search",
          inputProps: {
            "aria-label": rtlActive ? "بحث" : "Search",
            className: classes.searchInput
          },
          onKeyUp: e => {
              // e.preventDefault();
              if (e.which === 13 || e.keyCode === 13) {
                  // handlePress(e.target.value);
                  redirectToDashboard();
              }
          }
        }}
      /> */}

      <label style={{ fontSize:"16px", marginRight:"10px" }}>Sucursal: { sucursalLogueada }</label>

      {
        (esmatriz=='s') ?
          <Tooltip title="Cambiar de sucursal" placement="left">
            <Button
              color="white"
              onClick={seleccionarSucursalClick}
              aria-label="edit"
              justIcon
              round
              // className={searchButton}
              // disabled={ (idSucursalLogueada>1) ? true : false}
            >
              <StoreIcon className={classes.headerLinksSvg + " " + classes.searchIcon} />
            </Button>
          </Tooltip>
        : ""
      }

      {campanita}

      {(esmatriz == 's' && sinPush && permiso === "denied") ? (
        <Tooltip title="Notificaciones del navegador bloqueadas para este sitio" placement="left">
          <NotificationsOffIcon style={{ color: "#f44336", fontSize: 18, verticalAlign: "middle", marginRight: 6 }} />
        </Tooltip>
      ) : null}


      <div className={managerClasses}>
      <Tooltip title="Cerrar Sesión" placement="left">
        <Button
          color="transparent"
          aria-label="Person"
          justIcon
          aria-owns={openProfile ? "profile-menu-list" : null}
          aria-haspopup="true"
          // onClick={handleClickProfile}
          onClick={handleLogOut}
          className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
          muiClasses={{
            label: rtlActive ? classes.labelRTL : ""
          }}
        >
          <ExitToAppIcon
            className={
              classes.headerLinksSvg +
              " " +
              (rtlActive
                ? classes.links + " " + classes.linksRTL
                : classes.links)
            }
          />
          {/* <Hidden mdUp implementation="css">
            <span onClick={handleClickProfile} className={classes.linkText}>
              {rtlActive ? "الملف الشخصي" : "Profile"}
            </span>
          </Hidden> */}
        </Button>
        </Tooltip>
      </div>
    </div>
  );
}

HeaderLinks.propTypes = {
  rtlActive: PropTypes.bool,
  history: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
      "listDataSucursales": state.catalogosucursal.catalogoSucursal_List,
      "totalPendientes": state.notificaciones.total,
      "recientes": state.notificaciones.recientes,
      "noVistas": state.notificaciones.noVistas,
      "tokenEstado": state.notificaciones.tokenEstado,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    "logout": () => dispatch(logout()),
    "cambiarsucursal": (idsucursal,nombresucursal) => dispatch(cambiarsucursal(idsucursal,nombresucursal)),
    "getSucursales": () => dispatch(getSucursales()),
    "marcarVistas": () => dispatch(marcarVistas()),
    "registrarTokenWeb": (pedirPermiso) => dispatch(registrarTokenWeb(pedirPermiso)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLinks);
